import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { HrEmployees, SchTravelRequestLegs, SchTravelRequestBags, SchResources } from 'src/models';
import { TravelRequestStatusEnum, LodgingAuthTypeEnum, RentalCarAuthTypeEnum, DepartAndArriveTypeEnum } from '../aims-scheduler/aims-scheduler.classes';
import { TravelRequest, TravelRequestLegs, TravelRequestBags } from '../schCommon';
import * as moment from 'moment-mini';
import { isPlatformBrowser } from '@angular/common';
import { take } from 'rxjs/operators';
import { AimsCommonConfirmDialogComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { DialogComponent } from 'src/app/services/message/message.enum';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message/message.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-travel-request',
  templateUrl: './travel-request.component.html',
  styleUrls: ['./travel-request.component.scss']
})
export class TravelRequestComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private router: Router,
    public permissions: PermissionsService,
    private dialog: MatDialog,
    private messageService: MessageService) { }

  // Leg table
  legTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    filter: false
  };
  legTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'travelLeg', label: 'Leg', type: 'string', width: 70, validatorOrOpts: [Validators.required], },
    { key: 'travelFromId', label: 'From', type: 'dynamic', validatorOrOpts: [Validators.required]},
    { key: 'travelToId', label: 'To', type: 'dynamic', validatorOrOpts: [Validators.required]},
    { key: 'travelOn', label: 'Travel On', type: 'dynamic', },
    { key: 'departId', label: 'Depart', type: 'dynamic', },
    { key: 'arriveId', label: 'Arrive', type: 'dynamic', },
    { key: 'travelerTypeId', label: 'Traveler Type', type: 'dynamic', validatorOrOpts: [Validators.required]},
    { key: 'militaryNonSupported', label: 'Non-Supported', type: 'boolean', },
    { key: 'taskCodeId', label: 'Task Code', type: 'dynamic', validatorOrOpts: [Validators.required]},
    { key: 'oanumber', label: 'Over & Above #', type: 'dynamic', },
    { key: 'scheduleItemId', label: 'Schedule Item', type: 'dynamic', validatorOrOpts: [Validators.required]},
  ];

  public updateTablePermissions() {
    this.legTablePermissions.create = this.calculateEditable() && !this.isSubmitted();
    this.legTablePermissions.update = this.calculateEditable() && !this.isSubmitted();
    this.legTablePermissions.delete = this.calculateEditable() && !this.isSubmitted();

    this.baggageTablePermissions.create = this.calculateEditable() && !this.isSubmitted();
    this.baggageTablePermissions.update = this.calculateEditable() && !this.isSubmitted();
    this.baggageTablePermissions.delete = this.calculateEditable() && !this.isSubmitted();
  }

  public hideLegTableColumns() {
      var column = this.legTableHeader.find(el => el.key == 'militaryNonSupported');
      column.hidden = !this.tr.militaryTransportAuthorized

      this.legTableHeader = [...this.legTableHeader];
  }

  public handleLegRowUpdate(update: TableRowUpdate): void {
    const updatedLeg: SchTravelRequestLegs = update.newRow as SchTravelRequestLegs;
    this.tr.schTravelRequestLegs[update.index] = updatedLeg;
    this.tr.schTravelRequestLegs = [...this.tr.schTravelRequestLegs];
  }

  public handleLegRowAdd(update: TableRowUpdate){
    const item: SchTravelRequestLegs = update.newRow as SchTravelRequestLegs;
    this.tr.schTravelRequestLegs = [item, ...this.tr.schTravelRequestLegs];
  }

  public handleLegRowDelete(deleted: TableRowDelete) {
    this.tr.schTravelRequestLegs.splice(deleted.index, 1);
    this.tr.schTravelRequestLegs = [...this.tr.schTravelRequestLegs];
  }

  // Baggage table
  baggageTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    filter: false
  };
  baggageTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'travelRequestBagTypeId', label: 'Contents', type: 'dynamic', validatorOrOpts: [Validators.required]},
    { key: 'weight', label: 'Weight', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(5)]},
    { key: 'oversize', label: 'Oversize', type: 'boolean', },
  ];
  public handleBaggageRowUpdate(update: TableRowUpdate): void {
    const updatedLeg: SchTravelRequestBags = update.newRow as SchTravelRequestBags;
    this.tr.schTravelRequestBags[update.index] = updatedLeg;
    this.tr.schTravelRequestBags = [...this.tr.schTravelRequestBags];
  }

  public handleBaggageRowAdd(update: TableRowUpdate){
    const item: SchTravelRequestBags = update.newRow as SchTravelRequestBags;
    this.tr.schTravelRequestBags = [item, ...this.tr.schTravelRequestBags];
  }

  public handleBaggageRowDelete(deleted: TableRowDelete) {
    this.tr.schTravelRequestBags.splice(deleted.index, 1);
    this.tr.schTravelRequestBags = [...this.tr.schTravelRequestBags];
  }

  user = this.transferHttp.getCache('user');
  m = moment;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  newTr: boolean = false;

  //Field Values
  tr: TravelRequest = new TravelRequest();
  defaultTrLegs: SchTravelRequestLegs = new TravelRequestLegs();
  defaultTrBags: SchTravelRequestBags = new TravelRequestBags();

  emps = this.transferHttp.getCache<Array<HrEmployees>>('employeeDropdown');
  employeeValues = this.transferHttp.getSingle('Sch/GetAllEmployeesForLookUp');
  resourceValues = this.transferHttp.getSingle<Array<SchResources>>('Sch/GetResourcesForLookUp');
  defBagValues = this.transferHttp.getSingle(`User/GetTravelBagDefaults?travelerId=${this.user.employeeId}`);
  trStatusValues = this.transferHttp.getSingle('Sch/GetTravelRequestStatus');
  travelerTypeValues = this.transferHttp.getSingle('Sch/GetTravelerType');
  activeTravelerTypeValues = this.transferHttp.getSingle('Sch/GetActiveTravelerType');
  oaNumberValues = this.transferHttp.getSingle('Sch/GetOverAndAboveProjectsForDropdown');
  taskCodeValues = this.transferHttp.getSingle('Sch/GetTaskCode');
  siteValues = this.transferHttp.getSingle('Sch/GetScheduleAndTravelSites');
  departAndArriveValues = this.transferHttp.getSingle('Sch/GetDepartAndArriveType');
  lodgingAuthTypeValues = this.transferHttp.getSingle('Sch/GetLodgingAuthType');
  activeLodgingAuthTypeValues = this.transferHttp.getSingle('Sch/GetActiveLodgingAuthType');
  rentalCarAuthTypeValues = this.transferHttp.getSingle('Sch/GetRentalCarAuthType');
  activeRentalCarAuthTypeValues = this.transferHttp.getSingle('Sch/GetActiveRentalCarAuthType');
  flightAuthTypeValues = this.transferHttp.getSingle('Sch/GetFlightAuthType');
  activeFlightAuthTypeValues = this.transferHttp.getSingle('Sch/GetActiveFlightAuthType');
  travelRequestBagTypeValues = this.transferHttp.getSingle('Sch/GetTravelRequestBagType');

  //Used for aim-lookup
  scheduleItemLookupColumns:AimsCommonTableHeader[]  = [
    { key: 'fullName', label: 'Traveler', filter: true, type:AimsCommonTableHeaderType.STRING },
    { key: 'scheduleItemType', label: 'Type', filter: true, type:AimsCommonTableHeaderType.STRING },
    { key: 'siteName', label: 'Site',  filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'scheduleItemStart', label: 'Start', filter: true, type:AimsCommonTableHeaderType.STRING },
    { key: 'scheduleItemEnd', label: 'End', filter: true, type:AimsCommonTableHeaderType.STRING }
  ];

  employeeLookupColumns:AimsCommonTableHeader[]  = [
    { key: 'fullName', label: 'Name', filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'jobTitle', label: 'Job Title', filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'assignmentDescription', label: 'Assignment', filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'siteCode', label: 'Permanent Site',  filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'employmentType', label: 'Employment Type', filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'employeeStatus', label: 'Employee Status', filter: true, type:AimsCommonTableHeaderType.STRING },
    { key: 'employmentStatus', label: 'Employment Status', filter: true, type:AimsCommonTableHeaderType.STRING}
  ];

  resourceLookupColumns:AimsCommonTableHeader[]  = [
    { key: 'fullName', label: 'Name',  filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'grade', label: 'Grade',  filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'organizationName', label: 'Organization',  filter: true, type:AimsCommonTableHeaderType.STRING },
    { key: 'clearanceName', label: 'Clearance',  filter: true, type:AimsCommonTableHeaderType.STRING},
    { key: 'active', label: 'Active',  filter: true, type:AimsCommonTableHeaderType.BOOLEAN }
  ];

  siWithoutTrData = [];

  public getSiWithoutTr(empId: number, resId: number, travelOn: Date) {
    if (empId > 0 || resId > 0) {
      this.transferHttp.getSingle(`Sch/GetSiWithoutTr?empId=${empId}&resId=${resId}&travelOn=${moment(travelOn).format('YYYY-MM-DD')}`)
        .subscribe(data => {
          this.siWithoutTrData = data;
          this.showSpinner = false;
        });
    }
  }

  public loadTravelRequest(trId: string) {
    this.spinnerText = "Loading...";
    this.showSpinner = true;

    //Load Travel Request
    this.transferHttp.get('Sch/GetTravelRequestDetail?trId=' + trId).subscribe(tr => {
      //Set travelRequest fields
      this.tr = tr;
      this.tr.schTravelRequestLegs.sort((a, b) => a.travelLeg < b.travelLeg ? -1 : a.travelLeg > b.travelLeg ? 1 : 0);
      if (this.tr.employeeId != null) {
        this.tr.travelWeight = tr.employee.bodyWeight;
        this.tr.militaryTransportAuthorized = tr.employee.militaryTransportAuthorized;
      }
      else {
        this.tr.travelWeight = 0;
        this.tr.militaryTransportAuthorized = false;
      }
      this.newTr = false;
      this.showSpinner = false;
      this.getSiWithoutTr(this.tr.employeeId, this.tr.resourceId, this.tr.schTravelRequestLegs.filter(l => l.travelLeg == 1)[0].travelOn);
      this.updateTablePermissions();
      this.hideLegTableColumns();
    });
  }

  updateTravelOn(newDateValue){
    this.getSiWithoutTr(this.tr.employeeId, this.tr.resourceId, newDateValue);
  }

  public preLoadTRFromSI(siId: string) {
    this.newTr = true;
    this.spinnerText = "Loading...";
    this.showSpinner = true;

    this.transferHttp.getSingle('Sch/GetScheduleItemDetail?siId=' + siId).subscribe(si => {

      //PreLoad travelRequest fields from scheduleItem
      this.tr.travelRequestStatusId = TravelRequestStatusEnum.new;
      this.tr.employeeId = si.employeeId;
      this.tr.resourceId = si.resourceId;
      this.tr.requestedOn = new Date(moment(si.createdOn).format('MM/DD/YYYY'));
      this.tr.requestedById = si.createdById;
      this.tr.approvedById = null;
      this.tr.qualityControlledById = null;
      this.tr.travelWeight = (si.employeeId > 0) ? si.employee.bodyWeight : 0;
      this.tr.militaryTransportAuthorized = (si.employeeId > 0) ? si.employee.militaryTransportAuthorized : false;
      this.tr.nonRefundableAuth = true;
      this.tr.charter = false;
      this.tr.lodgingAuthTypeId = LodgingAuthTypeEnum.enroute;
      this.tr.rentalCarAuthTypeId = RentalCarAuthTypeEnum.no;
      this.tr.travelRequestComments = null;
      this.tr.createdById = this.user.employeeId;
      this.tr.createdOn = new Date();
      this.tr.sentToTravelAgent = false;

      let tr = new SchTravelRequestLegs();
      tr.travelLeg = 1;
      tr.travelFromId = null; //TODO: figure out how to prepopulate this
      tr.travelToId = si.siteId;
      tr.travelOn = si.scheduleItemStart;
      tr.scheduleItemId = si.scheduleItemId;

      this.tr.schTravelRequestLegs = [tr];

      this.getSiWithoutTr(si.employeeId, si.resourceId, si.scheduleItemStart);
      this.defBagValues = this.transferHttp.getSingle(`User/GetTravelBagDefaults?travelerId=${si.employeeId}`);
      this.defBagValues.subscribe(b => this.tr.schTravelRequestBags = b);

      this.updateTablePermissions();
      this.hideLegTableColumns();
      this.showSpinner = false;
    });
  }

  canApproveTravel(): boolean {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.TravelStep1Approval) ||
      this.permissions.canUpdate(this.permissions.ComponentID.TravelStep2Approval)) {
      returnVal = true;
    }
    return returnVal;
  }

  isNew(): boolean {
    return this.newTr;
  }

  isTraveler(): boolean {
    let returnVal = false;
    if (this.tr.employeeId == this.user.employeeId) {
      returnVal = true;
    }
    return returnVal;
  }

  isApproved(): boolean {
    let returnVal = false;

    if (this.tr.approvedById != null) {
      returnVal = true;
    }
    return returnVal;
  }

  isSubmitted(): boolean {
    let returnVal = false;

    if (this.tr.submittedOn != null) {
      returnVal = true;
    }
    return returnVal;
  }

  isSent(): boolean {
    return this.tr.sentToTravelAgent;
  }

  isChanged(): boolean {
    let returnVal = false;

    if (this.tr.travelRequestStatusId == TravelRequestStatusEnum.change) {
      returnVal = true;
    }
    return returnVal;
  }

  isCancelled(): boolean {
    let returnVal = false;

    if (this.tr.travelRequestStatusId == TravelRequestStatusEnum.cancellation) {
      returnVal = true;
    }
    return returnVal;
  }

  isConfirmed(): boolean {
    let returnVal = false;

    if (this.tr.confirmedOn != null) {
      returnVal = true;
    }
    return returnVal;
  }

  isQuoteOnly(): boolean {
    let returnVal = false;

    if (this.tr.travelRequestStatusId == TravelRequestStatusEnum.quoteOnly) {
      returnVal = true;
    }
    return returnVal;
  }

  submitTR() {
    //Check Status it might have been a Quote Only and never submitted before for approval
    if (this.tr.travelRequestStatusId != TravelRequestStatusEnum.new) {
      this.tr.travelRequestStatusId = TravelRequestStatusEnum.change;
    }
    this.tr.submittedOn = new Date();
    this.saveTravelRequest();
  }

  changeTR() {
    //"This will change the status to 'Change' and must be re-submitted and approved!"
    var message = this.messageService.getDialogMessage(DialogComponent.ChangeTravelRequest);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){


        this.tr.submittedOn = null;
        this.tr.approvedById = null;
        this.tr.approvedOn = null;
        this.tr.travelRequestStatusId = TravelRequestStatusEnum.change;
        if (this.tr.confirmedOn != null) {
          dialogRef = null;
          //"Do you also want to remove itinerary confirmation?"
          var message = this.messageService.getDialogMessage(DialogComponent.RemoveItineraryConfirmation);
          let dialogRef2 = this.dialog.open(AimsCommonConfirmDialogComponent,{
              data: message
          });
          dialogRef2.afterClosed().subscribe(dialogResult => {
            if(dialogResult){
              this.tr.confirmedOn = null;
            }
          });
          dialogRef2 = null;
        }
        this.saveTravelRequest();
      }
    });
  }

  cancelTR(sendEmail: boolean = true) {
    let message = null;
    if (sendEmail) {
      message = this.messageService.getDialogMessage(DialogComponent.CancelTravelRequest);
    } else {
      message = this.messageService.getDialogMessage(DialogComponent.CancelTravelRequestNoEmail);
    }
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.tr.travelRequestStatusId = TravelRequestStatusEnum.cancellation;
        if (sendEmail) {
          this.sendTravelRequestEmail(false);
        }
        else {
          this.sendTravelRequest();
        }
      }
      dialogRef = null;
    });
  }

  // no email version
  sendTravelRequest() {
    this.transferHttp.post('Sch/SendTR', this.tr).pipe(take(1)).subscribe();
  }

  sendTravelRequestEmail(sendExternal: boolean) {
    this.transferHttp.post(`Sch/SendTREmail?sendExternal=${sendExternal}`, this.tr).pipe(take(1)).subscribe(_ => {
      this.loadTravelRequest(this.tr.travelRequestId.toString());
    });
  }

  sendQuoteOnlyTravelRequestEmail() {
    //"This will change the status to 'Quote Only' and send out a email!"
    var message = this.messageService.getDialogMessage(DialogComponent.SendTravelRequestQuoteOnly);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.tr.travelRequestStatusId = TravelRequestStatusEnum.quoteOnly;
        this.sendTravelRequestEmail(true);
      }
      dialogRef = null;
    });
  }

  sendTravelRequestExternal() {
    //"This will be marked 'Sent' and send out a email internally and to Travel Agency!"
    var message = this.messageService.getDialogMessage(DialogComponent.SendTravelRequestExternal);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.sendTravelRequestEmail(true);
      }
      dialogRef = null;
    });
  }

  sendTravelRequestInternal() {
    //"This will send out a email internally ONLY!"
    var message = this.messageService.getDialogMessage(DialogComponent.SendTravelRequestInternal);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.sendTravelRequestEmail(true);
      }
      dialogRef = null;
    });
  }

  confirmTravelRequest() {
    //"This will change the status to 'Confirmation'!"
    var message = this.messageService.getDialogMessage(DialogComponent.ConfirmTravelRequest);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.tr.travelRequestStatusId = TravelRequestStatusEnum.confirmation;
        this.tr.confirmedOn = new Date();
        this.saveTravelRequest();
      }
      dialogRef = null;
    });
  }

  printTR() {
    this.router.navigate([`/reporting/TravelRequestHeader/trdp/{"TravelRequestID":"${this.tr.travelRequestId}"}`]);
  }

  calcSubmitText() {
    let retVal = "Submit";

    if (this.tr.submittedOn != null && this.tr.approvedOn == null) {
      retVal = "Awaiting Approval";
    }
    else if (this.tr.submittedOn != null && this.tr.approvedOn != null) {
      retVal = "Approved";
    }
    return retVal;
  }

  setDefaults() {
    this.newTr = true;
    this.tr.requestedOn = new Date();
    this.defBagValues.subscribe(b => this.tr.schTravelRequestBags = b);
    this.showSpinner = false;
  }

  calculateEditable() {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.TravelRequest)) {
      returnVal = true;
    }
    return returnVal;
  }

  step2ApprovalReq(): boolean {
    return this.tr.charter
      || (this.tr.schTravelRequestLegs.filter(l =>
        l.departId == DepartAndArriveTypeEnum.charter
        || l.arriveId == DepartAndArriveTypeEnum.charter
        || l.travelFrom.requiresStep2Approval
        || l.travelTo.requiresStep2Approval
      ).length > 0);
  }


  //approvals are handled on the server side
  public saveTravelRequest() {
    this.spinnerText = "Saving...";
    this.showSpinner = true;

    if (!this.newTr) {
      this.tr.modifiedById = this.user.employeeId;
      this.tr.modifiedOn = new Date();
    }
    this.transferHttp.put('Sch/SaveTravelRequest', this.tr).subscribe(retVal => {
      if (this.newTr) {
        this.newTr = false;
        this.router.navigate(['/scheduling/travelRequest/' + retVal.id]);
      }
      else {
        this.loadTravelRequest(retVal.id);
      }
    });
  }

  public verifyAtLeastOneLeg(): boolean {
    const legs = this.tr.schTravelRequestLegs;
    return (legs.length > 0 &&
      legs.filter(l => l.travelLeg == null || l.travelFromId == null || l.travelToId == null || l.taskCodeId == null || l.travelerTypeId == null)
        .length == 0
    );
  }

  //Cancel Input
  public cancelInput() {
    var message = this.messageService.getDialogMessage(DialogComponent.UnsavedChanges);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
        data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        if (isPlatformBrowser(this.platformId)) {
          //"Would you like to close this tab?"
          var message = this.messageService.getDialogMessage(DialogComponent.CloseTab);
          let dialogRef2 = this.dialog.open(AimsCommonConfirmDialogComponent,{
              data: message
          });
          dialogRef2.afterClosed().subscribe(dialogResult2 => {
            if(dialogResult2){
              window.close();
              this.router.navigate([`/scheduling`]);
            }else{
              this.loadTravelRequest(this.tr.travelRequestId.toString());
            }
          })
          dialogRef2 = null
        }
      }
      dialogRef = null;
    });
  }


  ngOnInit() {
    this.taskCodeValues.subscribe();
    this.siteValues.subscribe();
    this.departAndArriveValues.subscribe();
    this.lodgingAuthTypeValues.subscribe();
    this.rentalCarAuthTypeValues.subscribe();
    this.travelRequestBagTypeValues.subscribe();
    this.defBagValues.subscribe();
    this.resourceValues.subscribe();
    this.employeeValues.subscribe();

    //If id provided, load existing travel request data
    this.route.params.subscribe(p => {

      if (p['trId'] != 0) {
        this.loadTravelRequest(p['trId']);
      }
      else if (p['siId']) {
        this.preLoadTRFromSI(p['siId']);
      }
      else {
        this.setDefaults();
        this.updateTablePermissions();
        this.hideLegTableColumns();
      }
    });
  }

}
